import stars from 'client/modules/Surveys/pages/WebSurveyWidget/images/star.svg';
import thumbs from 'client/modules/Surveys/pages/WebSurveyWidget/images/thumb.svg';
import hearts from 'client/modules/Surveys/pages/WebSurveyWidget/images/heart.svg';
import csat1 from 'client/modules/Surveys/pages/WebSurveyWidget/images/csat-1.svg';
import csat2 from 'client/modules/Surveys/pages/WebSurveyWidget/images/csat-2.svg';
import csat3 from 'client/modules/Surveys/pages/WebSurveyWidget/images/csat-3.svg';
import csat4 from 'client/modules/Surveys/pages/WebSurveyWidget/images/csat-4.svg';
import csat5 from 'client/modules/Surveys/pages/WebSurveyWidget/images/csat-5.svg';
import * as React from 'preact';
import * as PropTypes from 'prop-types';
import cx from 'classnames';
import 'client/util/getContrastColor';

import styles from './AdditionalQuestionForm.css';

const iconMap = {
  hearts,
  thumbs,
  stars,
};

const csatMap = {
  1: csat1,
  2: csat2,
  3: csat3,
  4: csat4,
  5: csat5,
};

// Helper function to get CSS class names based on button style and shape
const getButtonClasses = (style, buttonStyle, buttonShape, selected) => {
  const baseClasses = cx(
    styles[style],
    style === 'numerical' ? styles.toggleButton : styles.iconButton,
    {
      [styles.selected]: selected,
      // Button style classes
      [styles.buttonStyleSolid]: buttonStyle === 'solid',
      // Button shape classes
      [styles.buttonShapeSquare]: buttonShape === 'square',
      [styles.buttonShapeRounded]: buttonShape === 'rounded',
      [styles.buttonShapeCircle]: buttonShape === 'circle',
    },
  );

  return baseClasses;
};

function ToggleButtonValue(props) {
  const animStart = (props.index + 1) * 0.032;
  if (props.style === 'numerical') {
    return <>{props.buttonValue}</>;
  }
  if (props.style === 'faces') {
    return (
      <div
        style={`animation: ${styles.pnWebBtnAnim} 0.325s linear ${animStart}s 1 normal both !important;`}
        dangerouslySetInnerHTML={{ __html: csatMap[`${props.buttonValue}`] }}
      />
    );
  }
  return (
    <div
      style={`animation: ${styles.pnWebBtnAnim} 0.325s linear ${animStart}s 1 normal both !important;`}
      dangerouslySetInnerHTML={{ __html: iconMap[props.style] }}
    />
  );
}

ToggleButtonValue.propTypes = {
  buttonValue: PropTypes.number.isRequired,
  style: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
};

function ToggleButton(props) {
  const handleChange = event => {
    event.preventDefault();
    props.onChange(event, props.value);
  };

  // Get CSS classes based on button style and shape
  const buttonClasses = getButtonClasses(
    props.style,
    props.buttonStyle || 'outlined',
    props.buttonShape || 'rounded',
    props.selected,
  );

  return (
    <button onClick={handleChange} type="button" value={props.value} className={buttonClasses}>
      <ToggleButtonValue buttonValue={props.value} style={props.style} index={props.index} />
      {props.children}
    </button>
  );
}

ToggleButton.propTypes = {
  value: PropTypes.number.isRequired,
  style: PropTypes.string.isRequired,
  buttonStyle: PropTypes.string,
  buttonShape: PropTypes.string,
  color: PropTypes.string,
  selected: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  children: PropTypes.node,
  index: PropTypes.number,
};

export default ToggleButton;
